// material
import ModernTable from '../../components/ModernTable';
import { TableInfoTitle } from './InfoTip';
import { MARKETING_INFO } from './marketingInfo';
import { useTheme } from '@mui/material/styles';
import { Box, Typography, Chip, alpha } from '@mui/material';

export default function BasicTable(props) {
  const theme = useTheme();
  const { data, machinesName } = props;

  // const MyNewTitle = ({ text = 'Table Title', variant = 'h6' }) => (
  //   <Typography variant={variant} style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
  //     {`Product Table (${machinesName} from ${startDate.toShortFormat()} to  ${endDate.toShortFormat()})`}
  //   </Typography>
  // );

  const Array = [data];

  const columns = [
    {
      title: 'Session Start',
      field: 'session_start',
      render: (rowData) => (
        <Chip
          label={rowData.session_start}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.primary.main, 0.12),
            color: theme.palette.primary.dark,
            border: `1.5px solid ${alpha(theme.palette.primary.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Session Complete',
      field: 'session_com',
      render: (rowData) => (
        <Chip
          label={rowData.session_com}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.success.main, 0.12),
            color: theme.palette.success.dark,
            border: `1.5px solid ${alpha(theme.palette.success.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'All Product',
      field: 'all_prod',
      render: (rowData) => (
        <Chip
          label={rowData.all_prod}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.info.main, 0.12),
            color: theme.palette.info.dark,
            border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'All Brand',
      field: 'all_brand',
      render: (rowData) => (
        <Chip
          label={rowData.all_brand}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.secondary.main, 0.12),
            color: theme.palette.secondary.dark,
            border: `1.5px solid ${alpha(theme.palette.secondary.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Cart Page',
      field: 'cart_page',
      render: (rowData) => (
        <Chip
          label={rowData.cart_page}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.primary.main, 0.12),
            color: theme.palette.primary.dark,
            border: `1.5px solid ${alpha(theme.palette.primary.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Cart Abandonment',
      field: 'cart_aband',
      render: (rowData) => (
        <Chip
          label={rowData.cart_aband}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.warning.main, 0.12),
            color: theme.palette.warning.dark,
            border: `1.5px solid ${alpha(theme.palette.warning.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'FAQ Page',
      field: 'faq',
      render: (rowData) => (
        <Chip
          label={rowData.faq}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.info.main, 0.12),
            color: theme.palette.info.dark,
            border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Ave Session Time(s)',
      field: 'aveSession',
      render: (rowData) => (
        <Chip
          label={rowData.aveSession}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.success.main, 0.12),
            color: theme.palette.success.dark,
            border: `1.5px solid ${alpha(theme.palette.success.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'English',
      field: 'language.en',
      render: (rowData) => (
        <Chip
          label={rowData.language?.en || 0}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.primary.main, 0.12),
            color: theme.palette.primary.dark,
            border: `1.5px solid ${alpha(theme.palette.primary.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'French',
      field: 'language.fr',
      render: (rowData) => (
        <Chip
          label={rowData.language?.fr || 0}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.info.main, 0.12),
            color: theme.palette.info.dark,
            border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Spanish',
      field: 'language.es',
      render: (rowData) => (
        <Chip
          label={rowData.language?.es || 0}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.secondary.main, 0.12),
            color: theme.palette.secondary.dark,
            border: `1.5px solid ${alpha(theme.palette.secondary.main, 0.3)}`,
          }}
        />
      ),
    },
  ];

  return (
    <ModernTable
      title={<TableInfoTitle title={'Basic Info: ' + machinesName} info={MARKETING_INFO.basic} />}
      columns={columns}
      data={Array}
      options={{
        actionsColumnIndex: -1,
        pageSize: 5,
      }}
    />
  );
}
